import {checkIfLinkShouldNotBeMasked} from '../../../../../../helper';

/**
 * @param {string} refinementText - Refinement text
 * @param {import('../../../../../type-definitions').Refinement} option - Refinement option
 * @returns {string} Refinement attributes HTML
 */
const getRefinementAttributesHTML = (refinementText, option) =>
    `class="value-link" title="${refinementText}" ${option.selected ? '' : option.genderPresentation}`;

/**
 * @param {string} iconClasses - Icon class
 * @param {import('../../../../../type-definitions').Refinement} option - Refinement option
 * @returns {string} Refinement HTML
 */
const getRefinementHTML = (iconClasses, option) =>
    `<span class="value-link-inner"><i class="${iconClasses}"><!-- icon --></i><span>${option.name}</span><span class="count">(${option.count})</span></span>`;

/**
 * @param {string} refinementText - Refinement text
 * @param {import('../../../../../type-definitions').Refinement} option - Refinement option
 * @param {string} url - Url
 * @param {string} iconClasses - Icon class
 * @returns {string} Refinement HTML
 */
const getMaskedRefinement = (refinementText, option, url, iconClasses) => {
    return `
        <span role="link" tabindex="0" rel="nofollow" ${getRefinementAttributesHTML(
            refinementText,
            option
        )} data-href="${url}">
            ${getRefinementHTML(iconClasses, option)}
        </span>
    `;
};

/**
 * @param {string} refinementText - Refinement text
 * @param {import('../../../../../type-definitions').Refinement} option - Refinement option
 * @param {string} url - Url
 * @param {string} iconClasses - Icon class
 * @returns {string} Refinement HTML
 */
const getUnmaskedRefinement = (refinementText, option, url, iconClasses) => {
    return `
        <a href="${url}" ${getRefinementAttributesHTML(refinementText, option)}>
            ${getRefinementHTML(iconClasses, option)}
        </a>
    `;
};

/**
 * @param {import('../../../../../../type-definitions').Refinement} refinement - refinement
 * @param {import('../../../../../../type-definitions').RefinementOption} option - refinement option
 * @param {import('../../../../../../interface/refinement-url-builder').default} refinementURLBuilder - url builder
 * @param {Object} seoUrlConfig - SEO exclude configuration
 * @returns {string} standard refinement option HTML
 */
export default (refinement, option, refinementURLBuilder, seoUrlConfig) => {
    const refinementClasses =
        ['upperMaterial', 'modelName'].indexOf(refinement.baseID) > -1 && window.Constants.SITE_ID === 'JP'
            ? 'refinement-fullwidth'
            : '';
    let refinementText = null;
    if (!option.selected) {
        refinementText = window.Resources.SEARCH_REFINEMENT_LABEL.replace('{0}', refinement.name).replace(
            '{1}',
            option.name
        );
    }
    if (refinementText === null) {
        refinementText = window.Resources.SEARCH_FILTERED_BY.replace('{0}', option.name);
    }
    const iconClasses = option.selected ? 'icon icon-checkbox_noborder' : 'icon icon-checkbox_unchecked_noborder';
    const url = option.selected
        ? refinementURLBuilder.getRefinementValueRemoveURL(refinement.id, option.value)
        : refinementURLBuilder.getRefinementValueURL(refinement.id, option.value);
    return `
        <li aria-checked="${option.selected ? 'true' : 'false'}" role="radio"
            class="value ${option.selected ? 'selected' : ''} ${refinementClasses}"
            data-refinement-id="${refinement.id}"
            data-refinement-info="${option.name}"
            data-refinement-value="${encodeURIComponent(option.value)}"
            data-is-selected="${option.selected ? 'true' : 'false'}">
            ${
                checkIfLinkShouldNotBeMasked(seoUrlConfig, {
                    name: refinement.id,
                    value: option.value
                })
                    ? getUnmaskedRefinement(refinementText, option, url, iconClasses)
                    : getMaskedRefinement(refinementText, option, url, iconClasses)
            }
        </li>
    `;
};
